import { render, staticRenderFns } from "./TipoSolicitacaoItem.vue?vue&type=template&id=d9040d3c&scoped=true&"
import script from "./TipoSolicitacaoItem.vue?vue&type=script&lang=js&"
export * from "./TipoSolicitacaoItem.vue?vue&type=script&lang=js&"
import style0 from "./TipoSolicitacaoItem.vue?vue&type=style&index=0&id=d9040d3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9040d3c",
  null
  
)

export default component.exports